import React from 'react';
import PropTypes from 'prop-types';

import IconContainer from 'presentation/components/icons/IconContainer';
import styles from 'presentation/components/styles/TryAgain.css';

export default function TryAgain(props) {
  TryAgain.propTypes = {
    buttonText: PropTypes.string.isRequired,
  };

  return (
    <div className={styles.tryAgain}>
      <div className={styles.tryAgainIcon}>
        <IconContainer
          className={styles.tryAgainIconContainer}
          viewBox="0 0 16 16"
          titleId="tryAgainButton"
          title="disconnect error button"
        >
          <path
            d="M11.547 6.684c.365.62.574 1.338.574 2.105 0 2.326-1.918 4.211-4.285 4.211-2.368 0-4.286-1.885-4.286-4.21 0-2.326 1.918-4.211 4.286-4.211h1.071"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M8.274 3l1.607 1.579-1.607 1.579" strokeLinecap="round" strokeLinejoin="round" />
        </IconContainer>
      </div>
      <span className={styles.tryAgainIcon}>{props.buttonText}</span>
    </div>
  );
}
